export default "uniform samplerCube cubeTexture;\n\nvoid main() {\n    gl_FragColor = textureCube(cubeTexture, vec3(1.0, 0.0, 1.0));\n}\n"